import { kebabCase } from 'lodash';
import { Select, SelectOption } from 'ui-components';
import { ISelectDropdownOption } from '~/components/SelectDropdown/SelectDropdown.types';
import {
  FEATURE_FLAGS,
  INSTAGRAM_CONTENT_TYPES,
  SOCIAL_PLATFORMS,
} from '~/constants';
import {
  CONTENT_SEARCH_ORDER_BY,
  CONTENT_SEARCH_ORDER_BY_NAMES,
  CONTENT_SEARCH_PARAMS,
} from '~/hooks/useContentSearch';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

import { IContentSearchComponentProps } from '../ContentSearchFilter.types';
import { getSortOptions } from '../ContentSearchFilter.utils';

export const ContentSearchFilterSort: React.FC<
  IContentSearchComponentProps & { isNewUi?: boolean }
> = ({
  onChange,
  filters: { platform, channel, sortBy },
  order,
  trackId,
  isDisabled,
  isNewUi,
}) => {
  const contentSearchAutocompleteDemoFlag = useFeatureFlag(
    FEATURE_FLAGS.foamDemoContentSearchAutocomplete,
  );
  const shouldShowRelevancySortBy =
    contentSearchAutocompleteDemoFlag === 'enabled';

  const options: ISelectDropdownOption[] = getSortOptions(
    platform as SOCIAL_PLATFORMS[],
    channel as INSTAGRAM_CONTENT_TYPES[],
    trackId,
  );

  if (shouldShowRelevancySortBy) {
    options.push({
      friendlyValue:
        CONTENT_SEARCH_ORDER_BY_NAMES[CONTENT_SEARCH_ORDER_BY.revelance],
      value: CONTENT_SEARCH_ORDER_BY.revelance,
      trackId: trackId
        ? trackId +
          '-' +
          kebabCase(
            CONTENT_SEARCH_ORDER_BY_NAMES[CONTENT_SEARCH_ORDER_BY.revelance],
          )
        : undefined,
    });
  }

  return (
    <Select
      defaultValue={sortBy ?? CONTENT_SEARCH_ORDER_BY.publishedAt}
      onChange={({ value }) =>
        onChange({ [CONTENT_SEARCH_PARAMS.sortBy]: value })
      }
      isFullWidth={false}
      order={order}
      placeholder="Select a sort option"
      prefix="Sorted by"
      trackId={trackId}
      variant={isNewUi ? ('gray' as any) : 'borderless'}
      isDisabled={isDisabled}
    >
      {options.map(({ friendlyValue, value, trackId }) => (
        <SelectOption key={value} value={value} trackId={trackId}>
          {friendlyValue}
        </SelectOption>
      ))}
    </Select>
  );
};
